export default {
    en: {
        THEME_EDITOR_TITLE: 'Theme Editor',
        THEME_EDITOR_FORM_INSTRUCTION: '* indicates a required field',
        THEME_EDITOR_SETTINGS_HEADER: 'Theme Settings',
        THEME_EDITOR_BACKGROUND_IMAGE_LABEL: 'Background Image',
        THEME_EDITOR_IS_DARK_LABEL: 'Dark Mode',
        THEME_EDITOR_IS_DARK_TOOLTIP: 'Controls the color scheme for browser elements (scrollbars, form inputs), which logo variant is displayed, and chart color palettes',
        THEME_EDITOR_LETTER_SPACING_LABEL: 'Letter Spacing',
        THEME_EDITOR_LETTER_SPACING_TOOLTIP: 'Adjusts the spacing between characters (e.g., "0.05em", "1px")',
        THEME_EDITOR_TEXT_SETTINGS_LEGEND: 'Text Settings',
        THEME_EDITOR_LANDING_FONT_LABEL: 'Landing Font',
        THEME_EDITOR_BUNDLED_FONT_LABEL: 'Font',
        THEME_EDITOR_BASE_THEME_LABEL: 'Base Theme',
        THEME_EDITOR_EXPORT_IMPORT_HEADER: 'Export / Import',
        THEME_EDITOR_THEME_NAME_LABEL: 'Theme Name',
        THEME_EDITOR_EXPORT_BUTTON: 'Export',
        THEME_EDITOR_IMPORT_BUTTON: 'Import',
    }
};
